module.exports = __webpack_public_path__ + "static/img/neec.7fcc7a6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/neec.svg
// module id = 2l+E
// module chunks = 0